/* @flow */
import hoistNonReactStatic from 'hoist-non-react-statics';
import KeyConstants from 'constants/KeyConstants';
import * as React from 'react';

export const layerStack = [];

function withLayerHideOnEscapeTrigger<Props: {}>(Child: React.ComponentType<Props>) {
  class LayerHideOnEscapeTrigger extends React.Component<Props> {
    // $FlowFixMe property `displayName` not found in Component object type
    displayName = `LayerHideOnEscapeTrigger(${Child.displayName})`;

    componentDidMount() {
      if (layerStack.length === 0) {
        document.addEventListener('keydown', this.handleDocumentKeyDown, false);
      }
      layerStack.push(this);
    }

    componentWillUnmount() {
      const index = layerStack.indexOf(this);
      if (index >= 0) {
        layerStack.splice(index, 1);

        if (layerStack.length === 0) {
          document.removeEventListener('keydown', this.handleDocumentKeyDown, false);
        }
      }
    }

    handleDocumentKeyDown: KeyboardEventListener = event => {
      if (event.keyCode === KeyConstants.ESCAPE) {
        let l = layerStack.length;
        while (l--) {
          const layer = layerStack[l];
          if (layer) {
            // $FlowFixMe type what stack array is
            if (!layer.props.onRequestHide) {
              console.warn(
                'component has hideOnEscapeTrigger without onRequestHide',
                layer.displayName
              );
              continue;
            }
            event.preventDefault();
            // $FlowFixMe type the layerStack
            layer.props.onRequestHide();
            break;
          }
        }
      }
    };

    render() {
      return <Child {...this.props} />;
    }
  }
  return hoistNonReactStatic(LayerHideOnEscapeTrigger, Child);
}

export default withLayerHideOnEscapeTrigger;
